export default "__VITE_ASSET__DQmrSDr___"